import React from "react";
import Link from "components/link/link";

export function AmpDownloadApp(props: any) {
  const { iosUrl, iosTitle, androidUrl, androidTitle } = props;

  return (
    <div className="download-app">
      <div className="download-app__item">
        <Link className="button button--primary" href={iosUrl} role="button">
          <span className="button__content">
            <span className="button__text">{iosTitle}</span>
          </span>
        </Link>
      </div>
      <div className="download-app__item">
        <Link
          className="button button--primary"
          href={androidUrl}
          role="button"
        >
          <span className="button__content">
            <span className="button__text">{androidTitle}</span>
          </span>
        </Link>
      </div>
    </div>
  );
}

export default AmpDownloadApp;
